import React from 'react';
import GuestChangePasswordForm from './form';

const bgStyles = {
  background: '#000',
};

const ChangePasswordPage = () => (
  <main className="page">
    <section style={bgStyles}>
      <div className="content">
        <div className="front-banner">
          <img
            src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg"
            alt="front-banner"
            className="banner-image"
          />
          <h3 className="front-header">Set a new password to continue</h3>
          <p className="front-paragraph">
            Your account is using a temporary password. Please choose a new
            password before continuing to your dashboard.
          </p>
        </div>
      </div>
      <div className="content-tight">
        <GuestChangePasswordForm />
      </div>
    </section>
  </main>
);

export default ChangePasswordPage;
